import { useEffect, useState } from "react";
import { api, eur, fmtError } from "../lib/api";
import { Reveal } from "./Reveal";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";

export const StudioSales = ({ isAdmin }) => {
  const [data, setData] = useState(null);

  const load = () => {
    api.get("/studio/sales").then((r) => setData(r.data)).catch(() => setData({ rows: [], totals: {} }));
  };
  useEffect(load, []);

  const deleteTestPurchase = async (r) => {
    if (!window.confirm(`Supprimer cet achat de test (${r.track_title} — ${r.buyer_email}) ? Le téléchargement sera révoqué et la vente retirée des statistiques.`)) {
      return;
    }
    try {
      await api.delete(`/admin/purchases/${r.order_id}`);
      toast.success("Achat de test supprimé");
      load();
    } catch (e) {
      toast.error(fmtError(e));
    }
  };

  if (!data) return null;
  const { rows, totals } = data;

  const cards = isAdmin
    ? [
        { label: "Ventes brutes", value: totals.gross },
        { label: "Votre commission", value: totals.commission },
        { label: "Reversé aux artistes", value: totals.artist_share },
      ]
    : [
        { label: "Ventes brutes", value: totals.gross },
        { label: "Commission plateforme", value: totals.commission },
        { label: "Votre part nette", value: totals.artist_share },
      ];

  return (
    <section className="border border-white/[0.08] bg-surface p-8" data-testid="studio-sales">
      <h2 className="font-display text-2xl font-medium">Ventes & revenus</h2>
      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
        {cards.map((c) => (
          <div key={c.label} className="border border-white/[0.08] p-5">
            <p className="text-[10px] uppercase tracking-[0.25em] text-zinc-500">{c.label}</p>
            <p className="mt-2 font-display text-3xl font-black text-amber-500" data-testid={`sales-${c.label}`}>
              {eur(c.value || 0)}
            </p>
          </div>
        ))}
      </div>
      {rows.length === 0 ? (
        <p className="mt-6 text-sm text-zinc-500" data-testid="sales-empty">
          Aucune vente pour le moment. Les montants apparaîtront ici dès le premier achat.
        </p>
      ) : (
        <div className="mt-6 overflow-x-auto">
          <table className="w-full text-left text-xs" data-testid="sales-table">
            <thead>
              <tr className="border-b border-white/10 text-[10px] uppercase tracking-[0.2em] text-zinc-500">
                <th className="py-2 pr-4">Date</th>
                <th className="py-2 pr-4">Morceau</th>
                {isAdmin && <th className="py-2 pr-4">Artiste</th>}
                <th className="py-2 pr-4">Acheteur</th>
                <th className="py-2 pr-4 text-right">Prix</th>
                <th className="py-2 text-right">{isAdmin ? "Commission" : "Votre part"}</th>
                {isAdmin && <th className="py-2 pl-4 text-right">Test</th>}
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i} className="border-b border-white/[0.05] text-zinc-300">
                  <td className="py-2.5 pr-4 text-zinc-500">
                    {new Date(r.created_at).toLocaleDateString("fr-FR")}
                  </td>
                  <td className="py-2.5 pr-4">{r.track_title}</td>
                  {isAdmin && <td className="py-2.5 pr-4 text-zinc-400">{r.artist_name}</td>}
                  <td className="py-2.5 pr-4 text-zinc-500">{r.buyer_email}</td>
                  <td className="py-2.5 pr-4 text-right">{eur(r.gross)}</td>
                  <td className="py-2.5 text-right font-bold text-amber-400">
                    {eur(isAdmin ? r.commission : r.artist_share)}
                  </td>
                  {isAdmin && (
                    <td className="py-2.5 pl-4 text-right">
                      <button
                        onClick={() => deleteTestPurchase(r)}
                        data-testid={`delete-sale-${r.track_id}`}
                        className="inline-flex h-8 w-8 items-center justify-center text-zinc-600 transition-colors hover:text-red-400"
                        title="Supprimer cet achat de test"
                      >
                        <Trash2 className="h-3.5 w-3.5" />
                      </button>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};
